module.exports = "<div class=\"_position-view\">\n\n  <v-layout row justify-center>\n\n    <v-flex xs12>\n      <transition name=\"fade\">\n        <cm-automation-details></cm-automation-details>\n      </transition>\n    </v-flex>\n\n  </v-layout>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/views/automationDetailView/automationDetailView.vue
// module id = 383
// module chunks = 0